import React from 'react'
import ReactDOM from 'react-dom'
import { IntlProvider } from "react-intl"
import FredriksonShop from './Screen/Fredrikson/FredriksonShop'
import { localeData } from './locale/localeData'
import { defaultLang } from './locale'
import reportWebVitals from './reportWebVitals'
import './index.css'
import './staticContent.css'
import './tooltipStyles.css'

// eslint-disable-next-line no-extend-native
Date.prototype.addDays = function(days: number) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}

ReactDOM.render(
  <React.StrictMode>
    <IntlProvider locale="en" messages={localeData[defaultLang]}>
      <FredriksonShop />
      {/* <Router>
        <Routes>
          <Route path={`${process.env.PUBLIC_URL}/`} element={<FredriksonShop />} />
        </Routes>
      </Router>
      */}
    </IntlProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
